import Announcement from './Announcement.container';

export default Announcement;
